/* eslint-env node, browser */
'use strict'
/**
 * called to set a 1 second timeout on the specified sequence
 *
 * this is so after each key press in the sequence you have 1 second
 * to press the next key before you have to start over
 *
 * @returns void
 */
module.exports = function () {
  var self = this

  clearTimeout(self.resetTimer)
  self.resetTimer = setTimeout(
    function () {
      self.resetSequences()
    },
    1000
  )
}



//////////////////
// WEBPACK FOOTER
// D:/agent/4/_work/121/s/common/~/combokeys/Combokeys/prototype/resetSequenceTimer.js
// module id = 149
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///D:/agent/4/_work/121/s/common/~/combokeys/Combokeys/prototype/resetSequenceTimer.js